import React from 'react';
import './skeleton.css';

// Base Skeleton Component
export const Skeleton = ({ width = '100%', height = '20px', className = '', variant = 'text' }) => {
  const variantClass = {
    text: 'skeleton-text',
    circular: 'skeleton-circular',
    rectangular: 'skeleton-rectangular',
  }[variant];

  return (
    <div
      className={`skeleton ${variantClass} ${className}`}
      style={{ width, height }}
    />
  );
};

// Skeleton Car Card Component
export const SkeletonCarCard = () => (
  <div className="col-md-4">
    <div className="CarBox">
      <div className="Image skeleton-car-image">
        <Skeleton variant="rectangular" width="100%" height="200px" />
        <div className="skeleton-tags">
          <Skeleton width="80px" height="24px" className="skeleton-tag" />
          <Skeleton width="120px" height="24px" className="skeleton-tag" />
        </div>
      </div>
      <div className="Content">
        <div className="Heading">
          <Skeleton width="60%" height="24px" className="mb-2" />
        </div>
        <div className="PriceMain">
          <div className="Price">
            <Skeleton width="80px" height="32px" className="mb-2" />
            <Skeleton width="100px" height="16px" className="mb-2" />
            <Skeleton width="100%" height="40px" />
          </div>
          <div className="Price">
            <Skeleton width="80px" height="32px" className="mb-2" />
            <Skeleton width="100px" height="16px" className="mb-2" />
            <Skeleton width="100%" height="40px" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

// Skeleton Car Grid (3 cards)
export const SkeletonCarGrid = ({ count = 3 }) => (
  <div className="container">
    <div className="row">
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonCarCard key={index} />
      ))}
    </div>
  </div>
);

// Skeleton for Top Cars Section
export const SkeletonTopCars = () => (
  <>
    <div className="CustomHeading1">
      <Skeleton width="60%" height="32px" className="mx-auto mb-3" />
      <Skeleton width="80%" height="20px" className="mx-auto" />
    </div>
    <section>
      <SkeletonCarGrid count={3} />
      <div className="row pt-4">
        <div className="Button text-center">
          <Skeleton width="150px" height="48px" className="mx-auto" />
        </div>
      </div>
    </section>
  </>
);

// Skeleton for Cars List Page
export const SkeletonCarsList = () => (
  <>
    <section className="MainSection">
      <div className="container">
        <Skeleton width="150px" height="36px" />
      </div>
    </section>
    <section>
      <SkeletonCarGrid count={9} />
    </section>
  </>
);

export default Skeleton;
